/*
* @Author: tengmaoqing
* @Date:   2018-06-13 20:28:48
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:54:27
*/
import Vue from 'vue';
import Vuex from 'vuex';
import User from '@/core/user/store';
import ManyLogin from '@/core/manyLogin/store';
// import createPlugin from 'logrocket-vuex';
import { merge } from 'lodash';

Vue.use(Vuex);

export const storeFnCreator = (configloader, initStore) => {
  const store = {
    state: {
      pid: 1001,
      phoneImgRoot: 'https://s1.huishoubao.com/img/phone/',
      apiHost: process.env.BASE_API || 'https://api.huishoubao.com',
      config: {}
    },
    actions: {
      // configSetting ({ commit }, config) {
      //   if (config) {
      //     return commit('setConfig', config);
      //   }
      // }
      // loadConfig ({ commit, state }) {
      //   const newConfig = configloader(state.pid);
      //   if (newConfig) {
      //     return commit('setConfig', newConfig);
      //   }
      // }
    },
    mutations: {
      setPid (state, pid) {
        if (Number(pid)) {
          state.pid = Number(pid);
        }
      },

      setConfig (state, config) {
        state.config = config;
      },

      loadConfig (state) {
        const newConfig = configloader(state.pid);
        state.config = newConfig;
      }
    },
    modules: {
      user: User,
      manyLogin: ManyLogin
    }
  };

  merge(store, initStore);

  if (process.env.VUE_ENV !== 'server' && process.env.NODE_ENV === 'production') {
    // const LogRocket = require('logrocket');
    // LogRocket.init('29pzmo/fd');
    // store.plugins = [createPlugin(LogRocket)];
  }
  return new Vuex.Store(store);
};



// WEBPACK FOOTER //
// ./src/system/init/init-store.js